const APPLICATION_PREFILTER_MAP = {
  'Potential Apps - Stage 00': { selectedStage: ['00 - Entrata'] },
  '00 - Entrata': { selectedStage: ['00 - Entrata'] },
  'Pending Apps - Stage 01-02A': {
    selectedStage: [
      '01 - Tenant Evaluation',
      '02 - Document Verification and Onboarding',
      '02A - Final Review',
    ],
  },
  'Pending Apps Stages 01-02A': {
    selectedStage: [
      '01 - Tenant Evaluation',
      '02 - Document Verification and Onboarding',
      '02A - Final Review',
    ],
  },
  /** Matches AppPerformanceReview “Pending Applications” KPI (stages 01, 02, 02A, and 04). */
  pending_apps_review_kpi: {
    selectedStage: [
      '01 - Tenant Evaluation',
      '02 - Document Verification and Onboarding',
      '02A - Final Review',
      '04 - Agreement Signed',
    ],
  },
  'Pending Payment - Stage 04': { selectedStage: ['04 - Agreement Signed'] },
  '04 - Agreement Signed': { selectedStage: ['04 - Agreement Signed'] },
  'Policy Issue - Stage 05': { selectedStage: ['05 - Policy Issued'] },
  'Policy Issued - Stage 05': { selectedStage: ['05 - Policy Issued'] },
  '05 - Policy Issued': { selectedStage: ['05 - Policy Issued'] },
  'Declined Application': { selectedStage: ['06 - Policy Declined'] },
  '06 - Policy Declined': { selectedStage: ['06 - Policy Declined'] },
  'Cancelled Application': { selectedStage: ['Cancelled Application'] },
  'LDR Commercial': { selectedAppType: ['LDR Commercial', 'LDR'] },
  LDR: { selectedAppType: ['LDR'] },
  'Rent Guaranty': { selectedAppType: ['Rent Guaranty'] },
  'Guarantor Waiver Program': { selectedAppType: ['Auto Enroll'] },
  'Guarantor Waiver': { selectedAppType: ['Auto Enroll'] },
  'Guaranty Waiver': { selectedAppType: ['Auto Enroll'] },
  'Auto Enroll': { selectedAppType: ['Auto Enroll'] },
  /** Application Distribution chart (stage row drilldown). */
  '01 - Tenant Evaluation': { selectedStage: ['01 - Tenant Evaluation'] },
  '02 - Document Verification and Onboarding': {
    selectedStage: ['02 - Document Verification and Onboarding'],
  },
  '02A - Final Review': { selectedStage: ['02A - Final Review'] },
};

export const getApplicationPrefilterByKey = (key) => {
  if (!key) return null;
  return APPLICATION_PREFILTER_MAP[key] || null;
};
